import React from 'react';

import { Modal } from '@/components/Modal';
import { LicenseType, ProductType } from '@/core/api/collections/users';

type Props = {
  onClose: () => void;
  onSubmit: () => void;
  open: boolean;
  product?: ProductType;
  licenseType?: LicenseType;
};
export function ProductRevokeConfirmationModal ({ licenseType, onClose, onSubmit, open, product }: Props) {
  let headerText = '';
  let bodyText = '';
  if (product === 'discovery') {
    let licenseTypePretty = '';
    switch (licenseType) {
      case 'contributor':
        licenseTypePretty = 'contributor';
        break;
      case 'fullaccess_admin':
        licenseTypePretty = 'admin';
        break;
      case 'helpdesk_admin':
        licenseTypePretty = 'support';
        break;
      default:
        licenseTypePretty = 'admin';
    }
    headerText = `Revoke ${licenseTypePretty} license to UserVoice?`;
    bodyText = `Are you sure you want to remove this user's ${licenseTypePretty} access from UserVoice? They will no longer be able to access any ${licenseTypePretty} features. Revoking access will not delete any of this user’s feedback or access to private forums.`;
  } else {
    headerText = 'Revoke access to Validation?';
    bodyText = 'Are you sure you want to remove this user\'s admin access from Validation? They will no longer be able to access any admin features.';
  }

  return (
    <Modal
      className="px-16 py-6"
      onClose={onClose}
      open={open}
      style={{ width: 525 }}
    >
      <div className={open ? '' : 'opacity-0'}>
        <div className="py-8">
          <h1 className="text-xl font-bold text-gray-900">{headerText}</h1>
          <div className="py-8">
            <p className="text-gray-800">{bodyText}</p>
          </div>
        </div>
        <div className="flex">
          <button className="w-40 h-12 mr-6 text-gray-600 bg-gray-100 rounded" onClick={onClose}>Cancel</button>
          <button className="w-40 h-12 text-gray-100 bg-blue-900 rounded" onClick={onSubmit}>Remove user</button>
        </div>
      </div>
    </Modal>
  );
}
